<template>
  <div class="document-allergies-tab-container">
    <div class="position-absolute w-100 h-100">
      <div class="overflow-auto w-100" style="height: calc(100% - 50px)">
        <div
          v-for="allergy in allergies"
          :key="allergy.id"
          class="d-flex flex-column mx-2 mb-4"
        >
          <div class="d-flex flex-row align-items-center">
            <div class="allergy-title">{{ allergy.allergyType.name }}</div>
            <div class="ml-auto">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                v-if="!readonly"
              >
                <template #button-content>
                  <i
                    class="fa fa-ellipsis-v color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"
                  >
                  </i>
                </template>
                <b-dropdown-item-button @click="editAllergy(allergy)"
                  >Edit</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="deleteAllergy(allergy)"
                  >Delete</b-dropdown-item-button
                >
              </b-dropdown>
            </div>
          </div>
          <div v-if="allergy.allergen != null" class="my-1 allergy-content">
            <b>Allergen</b>
            <br />
            <span v-if="allergy.allergen.name == 'Other'">{{
              allergy.otherAllergen
            }}</span>
            <span v-else>{{ allergy.allergen.name }}</span>
          </div>
          <div v-if="allergy.reaction != null" class="my-1 allergy-content">
            <b>Reaction</b>
            <br />
            <span v-if="allergy.reaction.name == 'Other'">{{
              allergy.otherReaction
            }}</span>
            <span v-else>{{ allergy.reaction.name }}</span>
          </div>
          <div v-if="allergy.severity != null" class="my-1 allergy-content">
            <b>Severity</b>
            <br />
            <span>{{ allergy.severity.name }}</span>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-center align-items-center"
        style="height: 50px"
      >
        <b-button :disabled="readonly" variant="primary" @click="addAllergy">
          Add Allergy
        </b-button>
      </div>
    </div>
    <patient-allergy-form
      v-if="showAllergyModal"
      v-model="showAllergyModal"
      :allergy="allergy"
      @ok="onAllergyModify"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { formatDateOnly } from "../../../helpers/date";
import allergyServer from "../../../server/allergy";
import PatientAllergyForm from "../../episode_of_care/PatientAllegyForm.vue";
export default {
  name: "DocumentAllergiesTabContent",
  components: {
    PatientAllergyForm
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: String
    }
  },
  data() {
    return {
      allergies: [],
      showAllergyModal: false,
      allergy: null
    };
  },
  async mounted() {
    await this.getAllergies();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getAllergies() {
      this.allergies = await allergyServer.query(this.patientId);
    },
    editAllergy(allergy) {
      this.allergy = { ...allergy };
      this.showAllergyModal = true;
      this.getAllergies();
    },
    deleteAllergy(allergy) {
      this.$dialog
        .alert(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await allergyServer.delete(allergy.id);
          this.getAllergies();
          this.$emit("onAllergyDelete", allergy.id);
          this.showAlertSuccess();
        });
    },
    addAllergy() {
      this.allergy = null;
      this.showAllergyModal = true;
    },
    formatDate(date) {
      return formatDateOnly(date);
    },

    async onAllergyModify(allergy) {
      this.showAllergyModal = false;
      let allergyData = {
        patientId: this.patientId,
        allergyTypeId: allergy.allergyType.id,
        allergenId: allergy.allergen?.id ?? null,
        reactionId: allergy.reaction?.id ?? null,
        severityId: allergy.severity?.id ?? null,
        otherAllergen: allergy.otherAllergen ?? null,
        otherReaction: allergy.otherReaction ?? null
      };
      if (allergy.id) {
        allergyData["id"] = allergy.id;
        await allergyServer.update(allergy.id, allergyData);
      } else {
        await allergyServer.create(allergyData);
      }
      this.getAllergies();
      allergyData.allergyTypeName = allergy.allergyType?.name ?? null;
      allergyData.allergenName = allergy.allergen?.name ?? null;
      allergyData.reactionName = allergy.reaction?.name ?? null;
      allergyData.severityName = allergy.severity?.name ?? null;
      this.$emit("onAllergyModify", allergyData);
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),

    ...mapGetters("layout", [
      "getCurrentAdjustedDateTime",
      "hasCurrentUserPermissionAccess"
    ])
  }
};
</script>

<style scoped>
.document-allergies-tab-container {
  position: relative;
  flex-grow: 1;
  width: 100%;
  height: 100%;
}
.allergy-title {
  font-size: 1.15rem;
  font-weight: 700;
}
.allergy-badge {
  max-height: 30px;
  padding-top: 2px;
  padding-bottom: 2px;
}
.allergy-description {
  font-size: 0.95rem;
}
.allergy-content {
  font-size: 0.9rem;
}
</style>
